import { WithUserNamespace } from '../../state/user';
import { getLoggedInUser } from './getLoggedInUser';

export const getUserLastName = (state: WithUserNamespace) =>
    getLoggedInUser(state)?.lastName || '';
